import { useWindowSize } from 'hooks/useWindowSize';
import { useEffect, useState } from 'react';
import { isMobileWidth } from 'utils/helpers';
import style from './NewsCategoryList.module.scss';

export type NewsItemCategoryType = {
  url?: string;
  name: string;
  slug: string;
};

export type NewsCategoryListType = {
  categories: NewsItemCategoryType[];
  onCategorySelect: (c: NewsItemCategoryType) => void;
  currentCategory: NewsItemCategoryType;
};
export const NewsCategoryList = ({
  categories,
  currentCategory,
  onCategorySelect,
}: NewsCategoryListType): JSX.Element => {
  const menuContentState = style.menuContentShow;

  return (
    <div className={style.container}>
      <div className={`${style.menuContent} ${menuContentState}`}>
        <ul className={style.list}>
          {categories.map((cat) => {
            const buttonState = currentCategory.url === cat.url ? style.buttonSelected : null;
            return (
              <li className={style.listItem} key={cat.name}>
                <button
                  type="button"
                  className={`${style.button} ${buttonState}`}
                  onClick={() => {
                    onCategorySelect(cat);
                  }}
                >
                  {cat.name}
                </button>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};
